<template>
  <div>
    <v-main>
      <v-container fluid>
        <!-- <app-headline :title="title + ' ของ ' + this.$username" /> -->
        <v-row>
          <v-col>
            <v-card
              class="pt-3 pb-6"
              :class="$vuetify.breakpoint.smAndUp ? 'px-8' : 'px-5'"
            >
              <v-container>
                <app-headline title="ข้อมูลส่วนตัว" />
                <v-divider class="mt-2"></v-divider>
                <data-display :data="userProfile" />

                <app-headline title="ข้อมูลเพิ่มเติม" />
                <v-divider class="mt-2"></v-divider>
                <data-display :data="additionData" :singleline="true" />

                <div v-if="fileUpload.length > 0">
                  <app-headline title="ไฟล์แนบ" />
                  <v-divider class="mt-2"></v-divider>
                  <v-row v-for="item in fileUpload" :key="item.id">
                    <v-col>
                      <a class="px-5" @click="downloadFile(item.title)">{{
                        item.title
                      }}</a>
                    </v-col>
                  </v-row>
                </div>

                <div v-if="fileImportList.length > 0">
                  <app-headline title="เอกสารที่ตรวจสอบแล้ว" />
                  <v-divider class="mt-2"></v-divider>
                  <v-row v-for="item in fileImportList" :key="item.id">
                    <v-col>
                      <a class="px-5" @click="downloadDoc(item.title)">{{
                        item.title
                      }}</a>
                    </v-col>
                  </v-row>
                </div>

                <div v-if="noted">
                  <app-headline title="Noted" />
                  <v-divider class="mt-2"></v-divider>
                  <v-row>
                    <v-col>
                      <div class="px-5">{{ noted }}</div>
                    </v-col>
                  </v-row>
                </div>

                <v-row class="mb-5" justify="end" align="center">
                  <!-- <v-icon large color="green">
                    mdi-check-circle-outline
                  </v-icon>
                  <v-chip class="ma-2" color="green" text-color="white">
                    ได้รับการตรวจสอบแล้ว
                  </v-chip> -->
                  <v-btn
                    v-if="
                      $route.params.type === 'admin' &&
                        (setApproveStatus === 2 || setApproveStatus === 4)
                    "
                    class="ma-2"
                    elevation="0"
                    color="success"
                    @click="dialogApprove = true"
                    >ยอมรับคำขอ</v-btn
                  >
                  <v-btn
                    v-if="
                      $route.params.type === 'admin' && setApproveStatus === 3
                    "
                    class="ma-2 white--text"
                    elevation="0"
                    color="orange"
                    @click="dialogApprove = true"
                    >ได้รับหนังสือจากกองวิเทศ</v-btn
                  >
                  <v-btn
                    v-if="
                      $route.params.type === 'admin' && setApproveStatus === 5
                    "
                    class="ma-2 white--text"
                    elevation="0"
                    color="orange"
                    @click="dialogApprove = true"
                    >ผู้เชี่ยวชาญตรวจสอบแล้ว/เสนอผู้บริหารลงนาม</v-btn
                  >
                  <v-btn
                    v-if="
                      $route.params.type === 'admin' && setApproveStatus === 6
                    "
                    class="ma-2 white--text"
                    elevation="0"
                    color="orange"
                    @click="dialogApprove = true"
                    >ส่งกลับกองบุคคล</v-btn
                  >
                  <v-btn
                    v-if="
                      $route.params.type === 'admin' &&
                        setApproveStatus === 7 &&
                        isPreviewed
                    "
                    class="ma-2"
                    elevation="0"
                    color="success"
                    @click="dialogApprove = true"
                    >จัดทำสำเร็จ</v-btn
                  >
                  <v-btn
                    v-if="
                      $route.params.type === 'admin' && setApproveStatus === 8
                    "
                    class="ma-2"
                    elevation="0"
                    color="success"
                    @click="dialogApprove = true"
                    >รับหนังสือรับรองแล้ว</v-btn
                  >
                  <v-btn
                    v-if="$route.params.type === 'admin' && statusId !== 1"
                    class="ma-2"
                    elevation="0"
                    color="secondary"
                    @click="dialogImport = true"
                    >Import File</v-btn
                  >
                  <v-btn
                    v-if="$route.params.type === 'admin' && statusId !== 1"
                    class="ma-2"
                    elevation="0"
                    color="primary"
                    @click="
                      $router.push('/ReqCer/preview/' + $route.params.cercode)
                    "
                    >PREVIEW</v-btn
                  >
                  <v-btn
                    v-if="$route.params.type === 'user' && statusId === 1"
                    class="ma-2"
                    elevation="0"
                    color="error"
                    @click="dialogDelete = true"
                    >ยกเลิกคำขอ</v-btn
                  >

                  <v-btn
                    @click="back()"
                    class="ma-2 white--text"
                    elevation="0"
                    color="grey"
                    >กลับ</v-btn
                  >
                </v-row>

                <app-headline title="สถานะการจัดทำ" />
                <v-divider class="mt-2"></v-divider>
                <status-stepper
                  :data="statusData"
                  :currentstep="currentstep"
                  :key="this.$vuetify.breakpoint.xsOnly"
                ></status-stepper>
                <status-table
                  :data="statusList"
                  :header="statusListHeader"
                ></status-table>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <v-dialog v-model="dialogApprove" max-width="320" persistent>
      <v-card>
        <div class="pa-4 font-weight-bold">ต้องการดำเนินการต่อหรือไม่</div>

        <div class="text-end pb-4 pr-4">
          <v-btn
            class="mx-1"
            color="success"
            depressed
            @click="onApproveStatus()"
          >
            ยืนยัน
          </v-btn>
          <v-btn
            class="mx-1"
            color="secondary"
            depressed
            @click="dialogApprove = false"
          >
            ยกเลิก
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDelete" max-width="320" persistent>
      <v-card>
        <div class="pa-4 font-weight-bold">ต้องการลบรายการหรือไม่</div>

        <div class="text-end pb-4 pr-4">
          <v-btn class="mx-1" color="error" depressed @click="apiDelete()">
            ลบ
          </v-btn>
          <v-btn
            class="mx-1"
            color="secondary"
            depressed
            @click="dialogDelete = false"
          >
            ยกเลิก
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogImport" max-width="480" persistent>
      <v-card>
        <div class="pa-4 font-weight-bold">อัพโหลดไฟล์</div>
        <div class="px-4 ">
          <v-file-input
            label="อัพโหลดไฟล์"
            v-model="file_temp"
            ref="fileImport"
            accept=".jpg, .jpeg, .png, .pdf,.doc,.docx"
            show-size
            outlined
            dense
            @change="onSelectFileImport"
          ></v-file-input>
        </div>

        <div class="text-end pb-4 pr-4">
          <v-btn
            class="mx-1"
            color="success"
            :disabled="!fileImport"
            depressed
            @click="apiImportDoc"
          >
            อัพโหลด
          </v-btn>
          <v-btn
            class="mx-1"
            color="secondary"
            depressed
            @click="dialogImport = false"
          >
            ยกเลิก
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DataDisplay from '@/components/reqcer/DataDisplay.vue'
import StatusStepper from '@/components/reqcer/StatusStepper.vue'
import StatusTable from '@/components/reqcer/StatusTable.vue'
export default {
  components: {
    DataDisplay,
    StatusStepper,
    StatusTable
  },
  data() {
    return {
      title: 'หนังสือรับรอง',
      currentstep: 3,
      userProfile: [],
      additionData: [],
      statusData: [],
      statusList: [],
      statusId: 0,
      isPreviewed: false,
      setApproveStatus: null,
      fileUpload: [],
      noted: null,
      dialogApprove: false,
      dialogDelete: false,
      dialogImport: false,
      fileImport: null,
      fileImportList: [],
      file_temp: null
    }
  },
  computed: {
    // printData() {
    //   return [
    //     {
    //       name: 'วันที่ออกหนังสือรับรอง',
    //       value: '10/9/2563'
    //     },
    //     {
    //       name: 'ที่ อว',
    //       value: '1234(7)/'
    //     },
    //     {
    //       name: 'ชื่อผู้ลงนาม',
    //       value: 'ผู้ช่วยศาสตราจารย์ ดร. ชรินทร์ เดชะพันธุ์'
    //     },
    //     {
    //       name: 'ตำแหน่ง',
    //       value: 'รองอธิการบดี'
    //     }
    //   ]
    // },

    statusListHeader() {
      return [
        { text: 'ลำดับที่', value: 'order' },
        { text: 'วันที่', value: 'createDate' },
        { text: 'เวลา', value: 'time' },
        { text: 'ผู้ดำเนินการ', value: 'officer' },
        { text: 'กระบวนการ', value: 'process' }
      ]
    }
  },

  mounted() {
    this.initialInfo()
  },
  methods: {
    back() {
      if (this.$route.params.type === 'admin') {
        this.$router.push('/ReqCer/admin')
      } else {
        this.$router.push('/ReqCer/list/' + this.$guid)
      }
    },
    async initialInfo() {
      let res = {}
      if (this.$route.params.type === 'admin') {
        res = await this.apiGetInfoAdmin()
      } else {
        res = await this.apiGetInfo()
      }

      const lang = this.$lang
      // console.log(res)

      const userDetail = res.data.data.userDetail || {}
      this.userProfile = [
        {
          id: 'nameSurnameTha',
          name: 'ชื่อ-นามสกุล',
          value: userDetail.nameSurnameTha
            ? userDetail.nameSurnameTha
            : this.$t('noData')
        },
        {
          id: 'nameSurnameEng',
          name: 'ชื่อ-นามสกุล (อังกฤษ)',
          value: userDetail.nameSurnameEng
            ? userDetail.nameSurnameEng
            : this.$t('noData')
        },
        {
          id: 'employeeTypeName',
          name: 'ประเภทบุคลากร',
          value: userDetail[`employeeTypeName${lang}`]
            ? userDetail[`employeeTypeName${lang}`]
            : this.$t('noData')
        },
        {
          id: 'positionName',
          name: 'ตำแหน่ง',
          value: userDetail[`positionName${lang}`]
            ? userDetail[`positionName${lang}`]
            : this.$t('noData')
        },
        {
          id: 'level',
          name: 'ระดับ',
          value: userDetail[`level${lang}`] ? userDetail[`level${lang}`] : '-'
        },

        {
          id: 'organizationFullName',
          name: 'สังกัดหน่วยงานปฏิบัติงานจริง',
          value: userDetail[`organizationFullName${lang}`]
            ? userDetail[`organizationFullName${lang}`]
            : this.$t('noData')
        }
      ]
      if (userDetail.salary) {
        this.userProfile.splice(5, 0, {
          id: 'salary',
          name: 'เงินเดือน',
          value: this.$currencyFilter(userDetail.salary) + ' บาท'
        })
      }

      if (userDetail.positionExecNameTha) {
        this.userProfile.push({
          id: 'positionExecName',
          name: 'ตำแหน่งบริหาร',
          value: userDetail[`positionExecName${lang}`]
            ? userDetail[`positionExecName${lang}`]
            : this.$t('noData')
        })
        this.userProfile.push({
          id: 'execSalary',
          name: 'ค่าตอบแทนบริหาร',
          value: userDetail.execSalary
            ? userDetail.execSalary
            : this.$t('noData')
        })
      }
      this.userProfile.push({
        id: 'dateStartWork',
        name: 'วันที่เริ่มทำงาน',
        value: userDetail.dateStartWork
          ? this.$dateFormatByLang(userDetail.dateStartWork)
          : this.$t('noData')
      })
      this.userProfile.push({
        id: 'nameSurnameTha',
        name: 'วันที่เปลี่ยนสถานภาพ',
        value: userDetail.dateChangeWork
          ? this.$dateFormatByLang(userDetail.dateChangeWork)
          : this.$t('noData')
      })
      if (userDetail.pension) {
        this.userProfile.push({
          id: 'pension',
          name: 'เงินบำนาญ',
          value: this.$currencyFilter(userDetail.pension) + ' บาท'
        })
      }
      if (userDetail.chor_Kor_Bor) {
        this.userProfile.push({
          id: 'chor_Kor_Bor',
          name: 'ช.ค.บ.',
          value: this.$currencyFilter(userDetail.chor_Kor_Bor) + ' บาท'
        })
      }
      if (userDetail.chor_Ror_Bor) {
        this.userProfile.push({
          id: 'chor_Ror_Bor',
          name: 'ช.ร.บ.',
          value: this.$currencyFilter(userDetail.chor_Ror_Bor) + ' บาท'
        })
      }

      const userDetailMore = res.data.data.userDetailMore || {}
      this.additionData = [
        {
          id: 'formReasonType',
          name: 'เหตุผล',
          value: userDetailMore[`formReasonType${lang}`]
            ? userDetailMore[`formReasonType${lang}`]
            : this.$t('noData')
        },
        {
          id: 'reasonText',
          name: 'เหตุผลเพิ่มเติม',
          value: userDetailMore.reasonText
            ? userDetailMore.reasonText
            : this.$t('noData')
        },
        {
          id: 'language',
          name: 'ภาษา',
          value: userDetailMore.language === 'Tha' ? 'ภาษาไทย' : 'ภาษาอังกฤษ'
        },
        {
          id: 'copy',
          name: 'จำนวน',
          value: userDetailMore.copy ? userDetailMore.copy : this.$t('noData')
        },
        {
          id: 'mobilePhone',
          name: 'เบอร์โทรศัพท์',
          value: userDetailMore.mobilePhone
            ? userDetailMore.mobilePhone
            : this.$t('noData')
        }
      ]
      if (userDetailMore.visaCountryTha) {
        this.additionData.splice(1, 0, {
          id: 'country',
          name: 'ไปประเทศ',
          value: userDetailMore.visaCountryTha
            ? userDetailMore.visaCountryTha
            : this.$t('noData')
        })
        this.additionData.splice(2, 0, {
          id: 'date',
          name: 'ตั้งแต่วันที่',
          value: userDetailMore.visaDate
            ? this.$dateFormatByLang(userDetailMore.visaDate.dateStart) +
              ' - ' +
              this.$dateFormatByLang(userDetailMore.visaDate.dateEnd)
            : this.$t('noData')
        })
      }

      this.fileUpload = []
      userDetailMore.fileUpload.forEach((item, index) => {
        let counter = this.$zeroPrefix(index + 1)
        this.fileUpload.push({
          id: 'File' + counter,
          title: item.fileName
        })
      })

      if (this.$route.params.type === 'admin') {
        this.fileImportList = []
        res.data.data.fileDoc.forEach((item, index) => {
          let counter = this.$zeroPrefix(index + 1)
          this.fileImportList.push({
            id: 'FileImport' + counter,
            title: item.fileName
          })
        })
      }

      this.noted = res.data.data.note

      this.initialStatusInfo(res.data.data.workingStatus)

      this.isPreviewed = res.data.data.isPreview
      this.setApproveStatus = res.data.data.setApproveStatus
      // console.log(res)
    },

    initialStatusInfo(workingStatus) {
      const processStatus = workingStatus.processStatusModelViewList || {}

      this.statusData = processStatus.map(item => {
        if (item.status === 'current') {
          this.currentstep = item.numberProcess
        }
        return {
          step: item.numberProcess,
          title: item.nameProcess,
          subtitle: this.$dateFormat(item.dateStampProcess),
          color: item.color
        }
      })

      const approveStatus = workingStatus.approveStatusModelViewList || {}

      this.statusList = approveStatus.map(item => {
        return {
          order: item.no,
          time: this.$dateFormat(item.dateStampProcess, { format: 'LT' }),
          createDate: this.$dateFormatByLang(item.dateStampProcess),
          officer: item.name,
          process: item.stepDetail
        }
      })

      this.statusId = workingStatus.trReqFormApproveStatusId
    },

    async onSelectFileImport() {
      const filename = event.target.files[0].name.split('.')
      const fileExt = filename[filename.length - 1].toLowerCase()
      const accepted = ['jpg', 'jpeg', 'png', 'pdf', 'doc', 'docx']

      if (accepted.includes(fileExt)) {
        this.fileImport = event.target.files[0]
      } else {
        await alert(this.$t('alertErrorMessage.noAcceptFileType'))
        this.fileImport = null
        this.file_temp = null
      }
    },

    async onApproveStatus() {
      await this.apiPutApproveStatus(this.setApproveStatus)

      this.initialInfo()
      // console.log(res)
    },

    async downloadFile(fileName) {
      const res = await this.apiDownloadFile(fileName)

      var fileURL = window.URL.createObjectURL(new Blob([res.data]))
      var fileLink = document.createElement('a')

      fileLink.href = fileURL
      fileLink.download = fileName
      // document.body.appendChild(fileLink)

      fileLink.click()
    },

    async downloadDoc(fileName) {
      const res = await this.apiDownloadDoc(fileName)

      var fileURL = window.URL.createObjectURL(new Blob([res.data]))
      var fileLink = document.createElement('a')

      fileLink.href = fileURL
      fileLink.download = fileName
      // document.body.appendChild(fileLink)

      fileLink.click()
    },

    async apiGetInfo() {
      try {
        const res = await this.$store.dispatch(
          'reqCer/getCertInfo',
          this.$route.params.cercode
        )
        return res
      } catch (e) {
        console.log(e.response || e)
      }
    },
    async apiDownloadFile(fileName) {
      try {
        const res = await this.$store.dispatch('reqCer/getDownloadFile', {
          id: this.$route.params.cercode,
          fileName: fileName
        })
        return res
      } catch (e) {
        console.log(e.response || e)
      }
    },

    async apiGetInfoAdmin() {
      try {
        const res = await this.$store.dispatch(
          'reqCer/getCertInfoAdmin',
          this.$route.params.cercode
        )
        return res
      } catch (e) {
        console.log(e.response || e)
      }
    },
    async apiDelete() {
      try {
        const res = await this.$store.dispatch(
          'reqCer/deleteCert',
          this.$route.params.cercode
        )
        this.dialogDelete = false
        this.back()
        return res
      } catch (e) {
        console.log(e.response || e)
      }
    },
    async apiImportDoc() {
      try {
        const res = await this.$store.dispatch('reqCer/importDoc', {
          file: this.fileImport,
          cercode: this.$route.params.cercode
        })
        this.dialogImport = false
        this.fileImport = null
        this.initialInfo()
        return res
      } catch (e) {
        console.log(e.response || e)
      }
    },
    async apiDownloadDoc(fileName) {
      try {
        const res = await this.$store.dispatch('reqCer/getDownloadDoc', {
          fileName: fileName,
          cercode: this.$route.params.cercode
        })
        return res
      } catch (e) {
        console.log(e.response || e)
      }
    },
    async apiPutApproveStatus(status) {
      try {
        const res = await this.$store.dispatch('reqCer/putApproveStatus', {
          cercode: this.$route.params.cercode,
          statusId: status
        })
        this.dialogApprove = false
        return res
      } catch (e) {
        console.log(e.response || e)
      }
    }
  }
}
</script>
